import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import {initSplideSlider} from './lib/SplideSlider';
import LazyLoad from "vanilla-lazyload";

const map = new Map();
export function initSplideSliders() {
    const splideSliders: NodeListOf<HTMLElement> = document.querySelectorAll('.splide');

    if (splideSliders.length) {
        Array.from(splideSliders).forEach((splideSlider) => {
            const lazyLoad = new LazyLoad({
                container: splideSlider,
                elements_selector: '.img-fluid',
                threshold: 200
            });

            const splide = initSplideSlider(splideSlider);

            if (splideSlider.dataset.autoscroll == '1') {
                splide.mount({AutoScroll})
            } else {
                splide.mount();
            }

            lazyLoad.update();

            splide.on('moved', () => {
                lazyLoad.update();
            });

            map.set(splideSlider, splide);
        });
    }
}

document.addEventListener('cms.reinit.slider', () => {
    map.forEach((splide, el) => {
        splide.destroy();
        map.delete(el);
    });

    initSplideSliders();
});

initSplideSliders();
